import { render, staticRenderFns } from "./worksDetails.vue?vue&type=template&id=c06d113e&scoped=true"
import script from "./worksDetails.vue?vue&type=script&lang=js"
export * from "./worksDetails.vue?vue&type=script&lang=js"
import style0 from "./worksDetails.vue?vue&type=style&index=0&id=c06d113e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06d113e",
  null
  
)

export default component.exports